import { useAuth } from "@/context/useAuth";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

type RouteType =
  | ({
      key: any;
      type: "collapse";
      name: string;
      icon: string | JSX.Element;
      noCollapse: boolean;
    } & ({ href: string } | { route: string }))
  | {
      key: any;
      type: "title";
      title: string;
    }
  | {
      key: any;
      type: "divider";
    };

export function useSidebarRoutes() {
  const { hasPermission, user } = useAuth();
  const { t } = useTranslation();


  return useMemo(() => {
    //////////
    //ICONS: https://fonts.google.com/icons
    let routes: RouteType[] = [
      {
        key: "title-dashboard-dispositivi",
        type: "title",
        title: t("sidebar.sezioni.dispositivi"),
      },
      user?.isEsterno === true
        ? {
            key: "home",
            type: "collapse",
            icon: "home",
            name: t("sidebar.voci.home"),
            route: "/home",
            noCollapse: true,
          }
        : null,
      hasPermission("DispositiviRead") && {
        key: "macchinari",
        type: "collapse",
        icon: "sensors",
        name: t("sidebar.voci.macchinari"),
        route: "/macchinari",
        noCollapse: true,
      },
      hasPermission("DispositiviRead") && {
        key: "sensori",
        type: "collapse",
        icon: "sensors",
        name: t("sidebar.voci.sensori"),
        route: "/sensori",
        noCollapse: true,
      },

      //TODO: manca il permesso CentraliRead analogo a DispositiviRead?
      // hasPermission("CentraliRead") &&
      user?.isEsterno === false && {
        key: "aziende",
        type: "collapse",
        icon: "factory",
        name: t("sidebar.voci.aziende"),
        route: "/aziende",
        noCollapse: true,
      },
      hasPermission("CalendarioInterventiRead") && {
        key: "calendario-interventi",
        type: "collapse",
        icon: "event",
        name: t("sidebar.voci.interventi"),
        route: "/calendario-interventi",
        noCollapse: true,
      },
      hasPermission("CalendarioTrasferimentiRead") && {
        key: "calendario-trasferimenti",
        type: "collapse",
        icon: "event",
        name: t("sidebar.voci.trasferimenti"),
        route: "/calendario-trasferimenti",
        noCollapse: true,
      },
      {
        key: "div",
        type: "divider",
      },
      {
        key: "title-impostazioni",
        type: "title",
        title: t("sidebar.sezioni.impostazioni"),
      },
      hasPermission("UsersEsterniRead") && {
        key: "clienti",
        type: "collapse",
        icon: "group",
        name: t("sidebar.voci.accountAziendali"),
        route: "/account_aziende",
        noCollapse: true,
      },
      hasPermission("UsersInterniRead") && {
        key: "utenti",
        type: "collapse",
        icon: "manage_accounts",
        name: t("sidebar.voci.utenti"),
        route: "/utenti",
        noCollapse: true,
      },
      hasPermission("RuoliPermessiRead") && {
        key: "ruoli_permessi",
        type: "collapse",
        icon: "lock_open_right",
        name: t("sidebar.voci.ruoliPermessi"),
        route: "/ruoli_permessi",
        noCollapse: true,
      },
      hasPermission("ModelliDispositivoChange") && {
        key: "modelli_dispositivi",
        type: "collapse",
        icon: "memory_alt",
        name: t("sidebar.voci.modelliDispositivi"),
        route: "/modelli_dispositivi",
        noCollapse: true,
      },
      (hasPermission("ModelliFiltroChange") ||
        hasPermission("ModelliOlioChange") ||
        hasPermission("DescrizioniBonificaChange")) && {
        key: "configurazione",
        type: "collapse",
        icon: "settings",
        name: t("sidebar.voci.configurazione"),
        route: "/configurazione",
        noCollapse: true,
      },
      hasPermission("RichiestePreventivoRead") && {
        key: "div",
        type: "divider",
      },
      hasPermission("RichiestePreventivoRead") && {
        key: "title-impostazioni",
        type: "title",
        title: t("sidebar.sezioni.fiera"),
      },
      hasPermission("RichiestePreventivoRead") && {
        key: "richieste_risparmi",
        type: "collapse",
        icon: "description",
        name: t("sidebar.voci.richiesteRisparmi"),
        route: "/richieste_risparmi",
        noCollapse: true,
      },
    ].filter((x) => x) as RouteType[];

    routes = routes.filter((x, index) => {
      // filter out title of empty sections
      return x.type === "title"
        ? index !== routes.length - 1 &&
            routes[index + 1].type !== "divider" &&
            routes[index + 1].type !== "title"
        : true;
    });

    // filter out divider of empty sections
    while (routes.length > 0 && routes[routes.length - 1].type === "divider") {
      routes.pop();
    }
    routes = routes.filter((x, index) => {
      // filter out divider of empty sections
      return x.type === "divider"
        ? index !== 0 && routes[index - 1].type !== "divider"
        : true;
    });

    return routes;
  }, [hasPermission, user, t]);
}
